module.exports = __webpack_public_path__ + "img/yjywgl-bg.b92c83c9.png";